(function () {
  var root = document.querySelector('[data-room-designer]');
  if (!root) return;

  var API_BASE = (root.getAttribute('data-rd-api-base') || '').replace(/\/$/, '');
  var USAGE_PROXY_PATH = root.getAttribute('data-rd-usage-proxy-path');
  // Phase 4D.28B: the credit-spending /api/redesign call no longer sends a
  // legacy signed customerId/issuedAt/token. Instead, immediately before
  // each generation attempt, the browser mints a short-lived, single-use
  // redesign token through this same-origin Shopify App Proxy path (Vercel
  // verifies it and derives the trusted customerId from it directly -- see
  // api/proxy/redesign-token.js / lib/redesign-token.js on the backend).
  // There is no legacy fallback: if this mint fails for any reason, the
  // generation attempt fails closed (see mintRedesignToken/handleGenerationError
  // below) rather than falling back to any signed-token construction.
  var TOKEN_PROXY_PATH = root.getAttribute('data-rd-token-proxy-path');
  var UPGRADE_URL = '/products/modern-studio-ai-plus';

  var uploadStep = root.querySelector('[data-rd-step="upload"]');
  var loadingStep = root.querySelector('[data-rd-step="loading"]');
  var resultStep = root.querySelector('[data-rd-step="result"]');
  var limitStep = root.querySelector('[data-rd-step="limit-reached"]');
  var limitHeadingEl = root.querySelector('[data-rd-limit-heading]');
  var limitTextEl = root.querySelector('[data-rd-limit-text]');
  var limitActionsEl = root.querySelector('[data-rd-limit-actions]');

  var dropzone = root.querySelector('[data-rd-dropzone]');
  var fileInput = root.querySelector('[data-rd-file-input]');
  var uploadPrompt = root.querySelector('[data-rd-upload-prompt]');
  var processingEl = root.querySelector('[data-rd-processing]');
  var previewImg = root.querySelector('[data-rd-preview]');
  var roomGrid = root.querySelector('[data-rd-room-grid]');
  var selectedRoomLabelEl = root.querySelector('[data-rd-selected-room-label]');
  var styleGrid = root.querySelector('[data-rd-style-grid]');
  var selectedStyleLabelEl = root.querySelector('[data-rd-selected-style-label]');
  var generateBtn = root.querySelector('[data-rd-generate]');
  var hintEl = root.querySelector('[data-rd-hint]');
  var errorEl = root.querySelector('[data-rd-error]');
  var beforeImg = root.querySelector('[data-rd-before-image]');
  var afterImg = root.querySelector('[data-rd-after-image]');
  var regenerateBtn = root.querySelector('[data-rd-regenerate]');
  var startOverBtn = root.querySelector('[data-rd-start-over]');
  var usageNoteEl = root.querySelector('[data-rd-usage-note]');
  var usageNoteResultEl = root.querySelector('[data-rd-usage-note-result]');

  var currentImageDataUrl = null;
  var selectedStyle = null;
  var selectedRoomType = null;
  var knownRemaining = null;
  var knownTier = null;
  // Set when the initial /api/usage check comes back 401 (a stale or
  // invalid App Proxy signature -- e.g. a page left open across a session
  // change), or when a redesign-token mint comes back 401 mid-session.
  // Distinct from a plain network failure. A 401 here means every later
  // call on this page load will 401 too, so rather than let someone fill
  // out the whole form and hit a wall at submission, we tell them up front
  // and keep Generate/Regenerate disabled until they refresh.
  var sessionInvalid = false;
  // Phase 4D.28B in-flight guard: prevents one user action (a double
  // click, a rapid repeat key/Enter dispatch, or any other duplicate event
  // firing) from starting a second concurrent token-mint/generation
  // sequence while one is already running. Cleared on every exit path
  // (success or failure) of runGeneration() below, so a thrown exception
  // can never leave Generate/Regenerate permanently unusable.
  var inFlight = false;

  function showStep(step) {
    [uploadStep, loadingStep, resultStep, limitStep].forEach(function (s) {
      if (s) s.hidden = (s !== step);
    });
  }

  function formatDate(isoDateStr) {
    if (!isoDateStr) return '';
    try {
      var d = new Date(isoDateStr + 'T00:00:00Z');
      return d.toLocaleDateString(undefined, { month: 'long', day: 'numeric', year: 'numeric', timeZone: 'UTC' });
    } catch (e) {
      return isoDateStr;
    }
  }

  // Populates the limit-reached screen differently depending on tier:
  // free-tier customers see the upgrade pitch (they don't have AI+ yet), but
  // an AI+ subscriber who's simply used all their credits for this period
  // would find "Upgrade to AI+" nonsensical — they already have it. That
  // customer instead sees when their credits reset, with no upsell.
  function populateLimitScreen(tier, renewsOn) {
    if (tier === 'ai_plus') {
      if (limitHeadingEl) limitHeadingEl.textContent = "You're Out of Credits for This Period";
      if (limitTextEl) {
        var renewText = renewsOn ? ' Your credits reset on ' + formatDate(renewsOn) + '.' : ' Your credits reset with your next billing cycle.';
        limitTextEl.textContent = "You've used all of your AI Design Credits for this billing period." + renewText;
      }
      if (limitActionsEl) {
        limitActionsEl.innerHTML =
          '<a href="/account" class="button button--primary">Manage Subscription</a>' +
          '<a href="/pages/modern-studio" class="button button--secondary">Explore Other Studio Tools</a>';
      }
    } else {
      if (limitHeadingEl) limitHeadingEl.textContent = "You've Used Your Free Designs";
      if (limitTextEl) limitTextEl.textContent = "You've used both of your free AI room designs. Upgrade to Môdern Studio™ AI+ for " +
        (typeof knownTotal === 'number' ? knownTotal : 20) + ' AI Design Credits every month, plus more features as they launch.';
      if (limitActionsEl) {
        limitActionsEl.innerHTML =
          '<a href="' + UPGRADE_URL + '" class="button button--primary">Upgrade to AI+ — $14.99/mo</a>' +
          '<a href="/collections/all" class="button button--secondary">Browse Collections</a>';
      }
    }
  }

  var knownTotal = null;

  // tier is 'free' or 'ai_plus'. AI+ now shows a real credit count (X of Y)
  // instead of a vague "design away" message, now that AI+ has an actual
  // monthly limit rather than being effectively unlimited.
  function updateUsageDisplay(remaining, tier, total) {
    knownRemaining = remaining;
    knownTier = tier;
    if (typeof total === 'number') knownTotal = total;

    var html;
    if (tier === 'ai_plus') {
      var totalLabel = typeof total === 'number' ? total : knownTotal;
      html = (totalLabel ? remaining + ' / ' + totalLabel + ' AI Design Credits remaining' : remaining + ' AI Design Credits remaining') +
        ' <a href="/account" class="rd-upgrade-link">Manage Subscription</a>';
    } else {
      var label = remaining === 1 ? '1 free design remaining' : remaining + ' free designs remaining';
      html = label + ' · <a href="' + UPGRADE_URL + '" class="rd-upgrade-link">Upgrade to AI+</a>';
    }
    if (usageNoteEl) usageNoteEl.innerHTML = html;
    if (usageNoteResultEl) usageNoteResultEl.innerHTML = html;
  }

  function checkReady() {
    generateBtn.disabled = sessionInvalid || !(currentImageDataUrl && selectedStyle && selectedRoomType);
  }

  function showError(msg) {
    errorEl.textContent = msg;
    errorEl.hidden = false;
  }
  function clearError() {
    errorEl.hidden = true;
    errorEl.textContent = '';
  }

  // On load, ask the server how many designs/credits this customer has left.
  // Both tiers now have a real, enforced limit, so both are checked the same
  // way — no more skipping the limit-reached screen for AI+.
  //
  // Unchanged by Phase 4D.28B: this call already went through the Shopify
  // App Proxy (Phase 4D.23) and carries no query string -- Shopify verifies
  // who is logged in server-side and appends a trusted logged_in_customer_id
  // before forwarding the request. All response handling below (remaining/
  // tier/total/renewsOn, the limit-reached screen, the 401 handling) is
  // unchanged.
  if (!USAGE_PROXY_PATH) {
    showError('The design service is not configured yet. Please try again later.');
  } else {
    fetch(USAGE_PROXY_PATH)
      .then(function (res) {
        // A 401 here means the App Proxy request could not be verified
        // (e.g. an invalid/stale signature) — every later call to this
        // same path will fail the same way. Surface that now rather than
        // letting someone fill out the whole form only to hit a wall.
        if (res.status === 401) {
          sessionInvalid = true;
          showError('Could not verify your session. Please refresh the page and try again.');
          checkReady();
          return null;
        }
        return res.json();
      })
      .then(function (data) {
        if (data && typeof data.remaining === 'number') {
          updateUsageDisplay(data.remaining, data.tier, data.total);
          if (data.remaining <= 0) {
            populateLimitScreen(data.tier, data.renewsOn);
            showStep(limitStep);
          }
        }
      })
      .catch(function () {
        // A genuine network hiccup (not a 401, which is handled above) —
        // let them try anyway; the redesign endpoint enforces the real
        // limit regardless.
      });
  }

  dropzone.addEventListener('click', function () { fileInput.click(); });
  dropzone.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); fileInput.click(); }
  });

  var MAX_SOURCE_BYTES = 30 * 1024 * 1024;
  var TARGET_DATA_URL_BYTES = 3.3 * 1024 * 1024;
  var DIMENSIONS_TO_TRY = [1600, 1400, 1200, 1000, 800];
  var QUALITIES_TO_TRY = [0.85, 0.75, 0.65, 0.55, 0.45];

  function compressToDataUrl(img) {
    var canvas = document.createElement('canvas');
    var ctx = canvas.getContext('2d');
    var longestSide = Math.max(img.naturalWidth, img.naturalHeight) || 1;
    var lastAttempt = null;

    for (var d = 0; d < DIMENSIONS_TO_TRY.length; d++) {
      var maxDim = DIMENSIONS_TO_TRY[d];
      var scale = Math.min(1, maxDim / longestSide);
      canvas.width = Math.max(1, Math.round(img.naturalWidth * scale));
      canvas.height = Math.max(1, Math.round(img.naturalHeight * scale));
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

      for (var q = 0; q < QUALITIES_TO_TRY.length; q++) {
        var dataUrl = canvas.toDataURL('image/jpeg', QUALITIES_TO_TRY[q]);
        lastAttempt = dataUrl;
        if (dataUrl.length <= TARGET_DATA_URL_BYTES) {
          return dataUrl;
        }
      }
    }
    return lastAttempt;
  }

  function prepareImage(file) {
    return new Promise(function (resolve, reject) {
      if (!file.type || file.type.indexOf('image/') !== 0) {
        reject(new Error('Please choose an image file.'));
        return;
      }
      if (file.size > MAX_SOURCE_BYTES) {
        reject(new Error('That photo is too large to process. Please choose a different photo.'));
        return;
      }

      var objectUrl = URL.createObjectURL(file);
      var img = new Image();
      img.onload = function () {
        URL.revokeObjectURL(objectUrl);
        try {
          var result = compressToDataUrl(img);
          if (!result) {
            reject(new Error('That photo could not be processed. Please try a different one.'));
            return;
          }
          resolve(result);
        } catch (err) {
          reject(new Error('That photo could not be processed. Please try a different one.'));
        }
      };
      img.onerror = function () {
        URL.revokeObjectURL(objectUrl);
        reject(new Error('That file could not be read as an image. Please try a JPG or PNG.'));
      };
      img.src = objectUrl;
    });
  }

  fileInput.addEventListener('change', function () {
    var file = fileInput.files && fileInput.files[0];
    if (!file) return;

    clearError();
    uploadPrompt.hidden = true;
    previewImg.hidden = true;
    processingEl.hidden = false;

    prepareImage(file)
      .then(function (dataUrl) {
        currentImageDataUrl = dataUrl;
        previewImg.src = currentImageDataUrl;
        previewImg.hidden = false;
        processingEl.hidden = true;
        checkReady();
      })
      .catch(function (err) {
        processingEl.hidden = true;
        uploadPrompt.hidden = false;
        showError(err.message || 'That photo could not be used. Please try a different one.');
      });
  });

  Array.prototype.forEach.call(roomGrid.querySelectorAll('.gift-chip'), function (btn) {
    btn.addEventListener('click', function () {
      Array.prototype.forEach.call(roomGrid.querySelectorAll('.gift-chip'), function (b) { b.classList.remove('is-selected'); });
      btn.classList.add('is-selected');
      selectedRoomType = btn.getAttribute('data-room');
      var roomName = btn.textContent.trim();
      if (selectedRoomLabelEl) {
        selectedRoomLabelEl.textContent = '— Selected: ' + roomName;
        selectedRoomLabelEl.hidden = false;
      }
      checkReady();
    });
  });

  Array.prototype.forEach.call(styleGrid.querySelectorAll('.gift-chip'), function (btn) {
    btn.addEventListener('click', function () {
      Array.prototype.forEach.call(styleGrid.querySelectorAll('.gift-chip'), function (b) { b.classList.remove('is-selected'); });
      btn.classList.add('is-selected');
      selectedStyle = btn.getAttribute('data-style');
      var styleName = btn.textContent.trim();
      if (selectedStyleLabelEl) {
        selectedStyleLabelEl.textContent = '— Selected: ' + styleName;
        selectedStyleLabelEl.hidden = false;
      }
      checkReady();
    });
  });

  // -- Phase 4D.28B: requestId lifecycle -----------------------------------
  //
  // One requestId identifies one LOGICAL generation attempt. It exists only
  // in memory for the lifetime of that attempt (and any TECHNICAL retry of
  // that exact same attempt) -- never persisted to localStorage,
  // sessionStorage, a URL, or a Project.
  //
  // A brand-new requestId is minted every time:
  //   - the person deliberately clicks Generate or Regenerate (even if the
  //     image/style/roomType are byte-for-byte identical to the previous
  //     successful generation -- Regenerate is an intentional new
  //     credit-consuming design request, never an idempotent replay of the
  //     prior one), or
  //   - the image, style, or room type changes before a retry.
  //
  // The SAME requestId would only ever be reused across a narrow, explicit
  // TECHNICAL retry of one already-initiated attempt (e.g. the mint or
  // POST failed transiently and the code itself, not a fresh user click,
  // retries it with a freshly minted token) -- this phase does not add any
  // such automatic retry loop (see runGeneration/handleGenerationError
  // below). Structurally, runGeneration(requestId) already takes the
  // requestId as a parameter rather than generating its own, so a future,
  // narrowly-scoped retry helper can call it again with the SAME requestId
  // it already has in scope, without inventing a second mechanism.
  function generateRequestId() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return window.crypto.randomUUID();
    }
    // Bounded fallback for browsers without crypto.randomUUID: produces
    // only characters in the backend-allowed charset ([A-Za-z0-9_-]), well
    // under the 128-character limit, with no braces or spaces.
    var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var out = '';
    for (var i = 0; i < 32; i++) {
      out += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return out;
  }

  // -- Phase 4D.28B: redesign-token mint -----------------------------------
  //
  // Mints exactly one short-lived, single-use redesign token immediately
  // before it is used. The returned token lives only in the local
  // `redesignToken` variable inside the .then() that consumes it (see
  // submitRedesign below) -- it is never assigned to an outer/reusable
  // variable, never logged, never written to the DOM, storage, or a URL,
  // and is never reused across more than one POST attempt.
  //
  // Fails closed on every error path: a network failure, a non-2xx status,
  // or a malformed 200 body all reject with an Error that
  // handleGenerationError (below) turns into a user-facing message -- none
  // of them fall back to constructing any legacy HMAC credentials.
  function mintRedesignToken() {
    if (!TOKEN_PROXY_PATH) {
      return Promise.reject(new Error('token_proxy_not_configured'));
    }
    return fetch(TOKEN_PROXY_PATH).then(function (res) {
      if (res.status === 401) {
        var authErr = new Error('not_authenticated');
        authErr.sessionInvalid = true;
        throw authErr;
      }
      if (!res.ok) {
        var httpErr = new Error('token_mint_failed');
        httpErr.status = res.status;
        throw httpErr;
      }
      return res.json().then(function (data) {
        if (!data || typeof data.token !== 'string' || data.token.length === 0 || typeof data.expiresIn !== 'number' || data.expiresIn <= 0) {
          throw new Error('token_mint_malformed');
        }
        return data.token;
      }, function () {
        throw new Error('token_mint_malformed');
      });
    });
  }

  // POSTs directly to Vercel with the new logical auth shape. `redesignToken`
  // is a parameter of this function only -- it never escapes into a
  // module-level variable, so it cannot be accidentally reused by a later
  // call.
  function submitRedesign(redesignToken, requestId) {
    return fetch(API_BASE + '/api/redesign', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        image: currentImageDataUrl,
        style: selectedStyle,
        roomType: selectedRoomType,
        redesignToken: redesignToken,
        requestId: requestId
      })
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) {
          var err = new Error((data && data.error) || 'Something went wrong.');
          err.status = res.status;
          err.limitReached = !!(data && data.limitReached);
          err.tier = data && data.tier;
          err.renewsOn = data && data.renewsOn;
          throw err;
        }
        return data;
      });
    });
  }

  function handleGenerationResult(data) {
    if (data && data.status === 'completed' && data.alreadyProcessed) {
      // Idempotent replay: the backend recognizes this requestId as
      // already completed (this only happens on a technical retry of one
      // attempt, never on a fresh Generate/Regenerate click, which always
      // uses a brand-new requestId). The replay response does not include
      // image data, so there is no new before/after pair to show -- we
      // update the usage/tier display (the one thing it does give us) and
      // say so plainly rather than fabricate a result or silently do
      // nothing.
      if (typeof data.remaining === 'number') updateUsageDisplay(data.remaining, data.tier, data.total);
      showStep(uploadStep);
      showError('That design was already generated. Please try again to create a new one.');
      return;
    }
    beforeImg.src = currentImageDataUrl;
    afterImg.src = data.image;
    if (typeof data.remaining === 'number') updateUsageDisplay(data.remaining, data.tier, data.total);
    showStep(resultStep);
  }

  function handleGenerationError(err) {
    if (err && err.sessionInvalid) {
      sessionInvalid = true;
      showStep(uploadStep);
      showError('Could not verify your session. Please refresh the page and try again.');
      checkReady();
      return;
    }
    if (err && err.status === 409) {
      // Another attempt under this exact requestId is already being
      // processed server-side. Do not mint a new requestId and do not
      // fire another generation automatically -- just tell them to wait.
      showStep(uploadStep);
      showError('Your previous design request is still processing. Please wait a moment and try again.');
      return;
    }
    if (err && err.limitReached) {
      populateLimitScreen(err.tier || knownTier, err.renewsOn);
      showStep(limitStep);
      return;
    }
    if (err && err.status === 429) {
      showStep(uploadStep);
      showError('Too many requests right now. Please wait a moment and try again.');
      return;
    }
    if (err && err.status === 400) {
      showStep(uploadStep);
      showError(err.message || 'That request could not be processed. Please try again.');
      return;
    }
    // Covers: token-mint network failure, token-mint 500, a malformed
    // token-mint response, /api/redesign network failure, and /api/redesign
    // 5xx / OpenAI failure. None of these fall back to legacy auth.
    showStep(uploadStep);
    showError((err && err.message) || 'Something went wrong. Please try again.');
  }

  // Runs one logical generation attempt end-to-end for the given
  // requestId: mint a fresh token, POST, handle the result. The in-flight
  // guard is cleared on both the success and failure branches, so a thrown
  // exception anywhere in the chain can never leave Generate/Regenerate
  // permanently disabled.
  function runGeneration(requestId) {
    inFlight = true;
    clearError();
    hintEl.hidden = true;
    showStep(loadingStep);

    mintRedesignToken()
      .then(function (redesignToken) {
        return submitRedesign(redesignToken, requestId);
      })
      .then(function (data) {
        inFlight = false;
        handleGenerationResult(data);
      })
      .catch(function (err) {
        inFlight = false;
        handleGenerationError(err);
      });
  }

  // Entry point for a deliberate user action (Generate or Regenerate).
  // Always mints a brand-new requestId -- see the requestId lifecycle
  // comment above for why this is correct even when Regenerate reuses the
  // same image/style/roomType.
  function startNewGeneration() {
    if (inFlight) return; // in-flight guard: ignore a duplicate trigger while one is already running
    if (!currentImageDataUrl || !selectedStyle || !selectedRoomType) {
      hintEl.hidden = false;
      return;
    }
    if (!API_BASE || !TOKEN_PROXY_PATH) {
      showError('The design service is not configured yet. Please try again later.');
      return;
    }
    if (sessionInvalid) {
      showError('Could not verify your session. Please refresh the page and try again.');
      return;
    }
    runGeneration(generateRequestId());
  }

  generateBtn.addEventListener('click', function () { startNewGeneration(); });
  regenerateBtn.addEventListener('click', function () { startNewGeneration(); });
  startOverBtn.addEventListener('click', function () {
    if (knownRemaining !== null && knownRemaining <= 0) {
      populateLimitScreen(knownTier, null);
      showStep(limitStep);
      return;
    }
    showStep(uploadStep);
  });
})();
